/**
 * Group icons for the settings hub, inlined from the design so they inherit `currentColor` and
 * pick up whichever THEME colour the card sets. No components-v2 equivalent exists for these
 * shapes; they are single-stroke line icons small enough to keep as JSX.
 */

interface IProps {
	className?: string;
}

const SIZE = 16;

function GroupIcon({ children, className }: React.PropsWithChildren<IProps>) {
	return (
		<svg
			aria-hidden
			className={className}
			width={SIZE}
			height={SIZE}
			viewBox='0 0 24 24'
			fill='none'
			stroke='currentColor'
			strokeWidth={2}
			strokeLinecap='round'
			strokeLinejoin='round'
		>
			{children}
		</svg>
	);
}

export function SettingsAdministrativeGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
		</GroupIcon>
	);
}

/** A sparkle, the usual mark for AI. web/components AIStarsIcon is gradient-filled and takes no
 *  className, so it cannot inherit the card's colour the way these do. */
export function AIGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<path d='M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9L12 3z' />
			<path d='M18.5 15.5l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8.8-2.2z' />
		</GroupIcon>
	);
}

export function FeaturesGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<polygon points='12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2' />
		</GroupIcon>
	);
}

export function EmailTrackingGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<rect x='2' y='4' width='20' height='16' rx='2' />
			<path d='M2 7l10 6 10-6' />
		</GroupIcon>
	);
}

export function PreApprovedContentGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<path d='M22 11.08V12a10 10 0 1 1-5.93-9.14' />
			<path d='M22 4L12 14.01l-3-3' />
		</GroupIcon>
	);
}

export function DashboardGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<rect x='3' y='3' width='7' height='9' />
			<rect x='14' y='3' width='7' height='5' />
			<rect x='14' y='12' width='7' height='9' />
			<rect x='3' y='16' width='7' height='5' />
		</GroupIcon>
	);
}

export function DataboardsGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<path d='M3 3v18h18' />
			<path d='M7 14l4-4 4 4 5-6' />
		</GroupIcon>
	);
}

export function PermanentGroupIcon({ className }: IProps) {
	return (
		<GroupIcon className={className}>
			<rect x='3' y='11' width='18' height='11' rx='2' />
			<path d='M7 11V7a5 5 0 0 1 10 0v4' />
		</GroupIcon>
	);
}
